import React from "react";

import { API } from '../api/APIClient'
import Axios from 'axios'
import {Link} from "react-router-dom";
import DataTable from 'react-data-table-component';
import SimpleAlertDialog, { ModalButton } from '../common/SimpleAlertDialog';


class Banner extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            modalOpen: false,
            modalTitle: "",
            modalMessage: "",
            modalButtons: []
        };


       // this.deleteIssue = this.deleteIssue.bind(this);

        this.handleChange = this.handleChange.bind(this);

    }


    handleChange(event) {

        const { name, type, value, checked } = event.target;

        this.setState({
            [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
        });
    }



    componentDidMount()
    {
        this.getBanner();
    }


    showAlertModal(title, message, buttons) {
        this.setState({
            modalOpen: true,
            modalTitle: title,
            modalMessage: message,
            modalButtons: buttons
        });
    }

    dismissAlertModal() {
        this.setState({
            modalOpen: false
        });
    }

    getBanner()
    {
        const formData = new FormData();

        Axios.post(API.jobs.getBanner, formData)
            .then((res) => {
                if (res.data.success) {
                    const data = res.data.data;

                    const now = new Date();
                    const pinnedStart = new Date(data.pinnedStart);
                    const pinnedEnd = new Date(data.pinnedEnd);

                    const isWithinPinnedWindow = now >= pinnedStart && now <= pinnedEnd;

                    this.setState({
                        enabled: isWithinPinnedWindow ? data.enabled : 0,
                        enableNum1: data.enableNum1,
                        num1: data.num1,
                        enableNum2: data.enableNum2,
                        num2: data.num2,
                        enableNum3: data.enableNum3,
                        num3: data.num3,
                        pinnedStart: data.pinnedStart,
                        pinnedEnd: data.pinnedEnd,
                        pinnedDaysRemaining: data.pinnedDaysRemaining,
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching banner:", error);
            });
    }


   submit() {

       const formData = new FormData();

       formData.append('enabled', this.state.enabled);
       formData.append('enableNum1', this.state.enableNum1);
       formData.append('num1', this.state.num1);
       formData.append('enableNum2', this.state.enableNum2);
       formData.append('num2', this.state.num2);
       formData.append('enableNum3', this.state.enableNum3);
       formData.append('num3', this.state.num3);
       formData.append('pinPostDays', this.state.pinnedDaysRemaining);

       // Send data to the server
       Axios
           .post(API.jobs.submitBanner, formData)
           .then((res) => {
               this.showAlertModal(
                   "Changes Saved",
                   (<div>The jobs banner changes have been saved.</div>),
                   [{ label: "OK", onClick: () => this.dismissAlertModal()}]
               );
               this.setState({
                   pigeonsInFlight : false
               }, this.getBanner());
           })
           .catch((error) => {
               console.error('Error:', error);
               this.setState({
                   pigeonsInFlight : false
               });
           });
    };





    render() {

            return (
                <div className="gas-cards">
                    <header className="header">
                        <Link to={"/"} ><div className="menu-icon"  >
                            <i className="fas fa-home"></i>
                        </div></Link>

                        <div className="big-logo"></div>

                        <div className="logout-icon" onClick={this.props.logoutHandler}>
                            {/* Logout icon */}
                            <i className="fas fa-sign-out-alt"></i>
                        </div>
                    </header>

                    <div  className="gas-cards-content" style={{width : "100%"}}>


                        <h1>Jobs Board Banner </h1>

                        <div className="issuedetail">


                            <div><span className="title">Show box 1 : </span> <span><input type="checkbox" name="enableNum1" checked={this.state.enableNum1 === 1} onChange={this.handleChange} /></span></div>
                            <div className="halfspacer"></div>
                            <div><span className="title">Box 1 number : </span> <span><input type="text" name="num1" value={this.state.num1} onChange={this.handleChange}/></span></div>
                            <div className="halfspacer"></div>
                            <div><hr/></div>

                            <div><span className="title">Show box 2 : </span> <span><input type="checkbox" name="enableNum2" checked={this.state.enableNum2 === 1} onChange={this.handleChange} /></span></div>
                            <div className="halfspacer"></div>
                            <div><span className="title">Box 2 number : </span> <span><input type="text" name="num2" value={this.state.num2} onChange={this.handleChange}/></span></div>
                            <div className="halfspacer"></div>
                            <div><hr/></div>

                            <div><span className="title">Show box 3 : </span> <span><input type="checkbox" name="enableNum3" checked={this.state.enableNum3 === 1} onChange={this.handleChange} /></span></div>
                            <div className="halfspacer"></div>
                            <div><span className="title">Box 3 number : </span> <span><input type="text" name="num3" value={this.state.num3} onChange={this.handleChange}/></span></div>
                            <div className="halfspacer"></div>
                            <div><hr/></div>

                            <div><span className="title">Show banner in app : </span> <span><input type="checkbox" name="enabled" checked={this.state.enabled === 1} onChange={this.handleChange} /></span></div>
                            <div className="halfspacer"></div>

                            <div><span className="title">Days Left : </span> <span>
                                <select value={this.state.pinnedDaysRemaining} onChange={this.handleChange} name="pinnedDaysRemaining">
                                     {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
                                         <option key={day} value={day}>
                                             {day}
                                         </option>
                                     ))}
                                </select>
                            </span></div>

                            <div className="ga-button " onClick={() => this.submit()}>Save</div>

                        </div>


                    </div>


                    <SimpleAlertDialog
                        open={this.state.modalOpen}
                        title={this.state.modalTitle}
                        message={this.state.modalMessage}
                    >
                        {
                            this.state.modalButtons.map((button, index) => (
                                <ModalButton
                                    key={index}
                                    label={button.label}
                                    onClick={button.onClick}
                                    className={button.className}
                                />
                            ))
                        }
                    </SimpleAlertDialog>


                </div>
            );


    }
}

export default Banner;
